<div class="page-header">
  <div class="grid-container">
  <div class="domain-header" [innerHtml]="domainName | domainNameConverter : true"></div>
  </div>
</div>
<div class="grid-container">
<div *ngIf="requestMetadata.requestType === DIRECT">
  <div class="content-header changes-implemented">Your changes have been implemented!</div>
</div>
<div *ngIf="requestMetadata.requestType !== DIRECT">
  <div class="content-header">Your request has been lodged!</div>
  <div class="header-helper">
    <div  *ngIf="!requestMetadata || !updateChangeRequest">
      <div *ngIf="showTicketNumber">
        <p>
          Below is a summary of the submitted change request and its reference number. Please use this number if contacting IANA about this request.
        </p>
        <p>
          ICANN will process the request according to its policies and procedures. The next step is usually to confirm that the domain’s authorizers approve the requested change.
        </p>
        <p>
          You can track the status of this request using this management interface.
        </p>
      </div>
      <div *ngIf="!showTicketNumber">
        Your changes are implemented
      </div>

    </div>
  </div>
</div>
<div class="content content-with-elevation">
  <div class="grid-y" *ngIf="!requestMetadata || !updateChangeRequest">
    <div class="grid-y" *ngIf="!deleteRequest">
      <div *ngFor="let changeRequest of requestConfirmation.tldChangeResult.changeRequestVO">
        <summary-of-changes [newDelegation]="newDelegation" [changeRequest]="changeRequest"
                            [showTicketNumbers]="showTicketNumber"></summary-of-changes>
      </div>
    </div>
    <div *ngIf="deleteRequest">
      <h4>{{requestConfirmation.tldChangeResult.changeRequestVO[0].id}}</h4>
      <p>TLD <b>"{{domainName | domainNameConverter}}"</b> is being revoked.</p>
    </div>
  </div>
  <div class="grid-y" *ngIf="updateChangeRequest">
    <div class="header-helper">Your changes have been updated</div>
    <div class="grid-y">
      <div *ngFor="let changeRequest of requestConfirmation.tldChangeResult.changeRequestVO">
        <summary-of-changes [newDelegation]="false" [changeRequest]="changeRequest"
                            [showTicketNumbers]="true"></summary-of-changes>
      </div>
    </div>
  </div>
  <div class="grid-x save-cancel-button-group" style="margin-top: 1rem;">
    <button class="iana-button" style="float: right" (click)="goToHome()">Return To Home</button>
  </div>
</div>
</div>
